import { Helmet } from 'react-helmet-async';
import projectsList from '../data/projects';
import SectionPageTitle from '../components/SectionPageTitle';
import ProjectOverlay from '../components/ProjectOverlay';

export default function Projects() {
	return (
		<>
			<Helmet>
				<title>Projects</title>
				<meta name="description" content="Gersem Business Services & IT Solutions Projects" />
				<meta name="keywords" content="projects, it projects, business plan, business projects" />
			</Helmet>

			<SectionPageTitle
				pageTitle={'Projects'} 
				subTitle={'We are unstoppable'}
			/>

			<section className="big-container">
				<div className="grid gtc-3 g-3">
					{projectsList.map((project, idx) =>
						<ProjectOverlay
							key={idx}
							img={project.img}
							projectName={project.name}
							category={project.category}
							url={project.url}
						/>
					)}
				</div>
			</section>
		</>
	);
}
